import { render, staticRenderFns } from "./CommunicationForm.vue?vue&type=template&id=1eb57ecc&"
import script from "./CommunicationForm.vue?vue&type=script&lang=js&"
export * from "./CommunicationForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationForm.vue?vue&type=style&index=0&id=1eb57ecc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports